import { LOGOUT_SUCCESS } from "../Types";
import {
  DELETE_VARIANTS_DATA,
  GET_BRANDS_DATA_SUCCESS,
  GET_DOCUMENT_TEMPLATE_SUCCESS,
  GET_MODELS_DATA_SUCCESS,
  GET_VARIANTS_DATA_SUCCESS,
} from "../Types/addVehicles";

const initalState = {
  brandsData: [],
  modelsData: [],
  variantsData: [],
  documentTemplateList: [],
};

export default function addVehiclesReducer(state = initalState, action) {
  switch (action.type) {
    case GET_BRANDS_DATA_SUCCESS: {
      return {
        ...state,
        brandsData: action.body.data,
      };
    }
    case GET_MODELS_DATA_SUCCESS: {
      const { data = [] } = action.body;
      return {
        ...state,
        modelsData: data,
      };
    }
    case GET_VARIANTS_DATA_SUCCESS: {
      const { data = [] } = action.body;
      return {
        ...state,
        variantsData: data,
      };
    }
    case GET_DOCUMENT_TEMPLATE_SUCCESS: {
      const { data = [] } = action.body;
      return {
        ...state,
        documentTemplateList: data,
      };
    }
    case DELETE_VARIANTS_DATA: {
      return {
        ...state,
        variantsData: [],
      };
    }
    case LOGOUT_SUCCESS: {
      return {
        ...initalState,
      };
    }
    default:
      return state;
  }
}
